
const ZindexUtils = {
 getMaxZIndex: (): number => {
  const elements = Array.from(document.querySelectorAll<HTMLElement>("*"));
  let maxZ = 0;

  elements.forEach(el => {
    const z = window.getComputedStyle(el).zIndex;
    if (z !== "auto") {
      const zi = parseInt(z, 10);
      if (!isNaN(zi) && zi < ZindexUtils.zIndexBar()) {
        maxZ = Math.max(maxZ, zi);
      }
    }
  });

  // garante que nunca ultrapasse 999999
  return Math.min(maxZ, 9999998);
}
  ,
   zIndexBar: (): number => {
    
    return 9999999;
  }


};
export { ZindexUtils };

